import Amplitude from 'react-amplitude'
import config from '../config'

// amplitude folks changed everything, I hate them

export default function(fn, arg, props) {
  // return config.isProd ? Amplitude[fn](arg, props) : true
}

export function amplitudeEvent(name, props) {
  // return config.isProd ? Amplitude['logEvent'](name, props) : true
}
